// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Ek2Jdc6PoEFAitIR7Na1","button":"r69ws1rX2FbUNX1Qbmgg","icon":"o9_yOUPOGHMrSvtWocQh"};